import {notify} from "@housebets/housebets-x-package";
import {ICardProps} from "@housebets/housebets-x-package/lib/components/cards/Card/types";
import {IUserInfoModalReward} from "@housebets/housebets-x-package/lib/components/feature/modals/UserInfoModal/UserInfoRewardsList/types";
import {useEffect, useMemo, useState} from "react";
import apiCasino from "app/api/casino";
import {useAppSelector} from "hooks/useAppSelector";
import {getAvatarUrl, getMappedCardList} from "app/utils/help";
import { useLangNavigate } from "app/hooks/useLangNavigate";
import { useIntl } from "react-intl";

export const useUserInfoModalData = () => {
    const userData = useAppSelector((state) => state.user.user);
    const platformConfig = useAppSelector((state) => state.config.platformConfig);
    const [recentlyGames, setRecentlyGames] = useState<ICardProps[]>([]);
    const {$t} = useIntl();
    const langNavigate = useLangNavigate();

    const rewards: IUserInfoModalReward[] = [
        {
            icon: "instant_rakeback",
            name: "Instant Rakeback",
        },
        {
            icon: "daily_rakeback",
            name: "Daily Rakeback",
        },
        {
            icon: "week_reload",
            name: "Weekly Bonus",
        },
        {
            icon: "month_reload",
            name: "Monthly Bonus",
        },
        {
            icon: "airdrop",
            name: "Level Up",
        },
        {
            icon: "vip_reload",
            name: "VIP Reload",
        },
        {
            icon: "deposit",
            name: "Deposit Bonus",
        },
    ];

    const vipWidgetData = useMemo(() => {
        const vipList = platformConfig?.vipList || [];
        const currentLevel = vipList?.find((v) => v.level === userData?.level);
        const nextLevel = vipList?.find((v) => v.level === (userData?.level || 0) + 1);
        const levelTitle = currentLevel?.name;
        const levelNextTitle = nextLevel?.name;
        const matchName = levelTitle?.match(/^([^\d]+)\s*(\d+)$/);
        return {
            name: userData?.nick || "",
            level: userData?.exp || 0,
            maxLevel: nextLevel?.exp || userData?.exp || 0,
            levelTitleOriginal: levelTitle || '',
            levelTitle: matchName?.length && matchName[2] !== undefined
                    ? $t({ id: String(matchName[1]?.trim() || '') }) + ' ' + matchName[2]
                    : '',
            levelNextTitle: levelNextTitle || "",
            levelNumber: userData?.level,
            amount: userData?.exp || 0,
        };
    }, [userData, platformConfig]);

    const mutatedUserData = useMemo(() => {
        return {
            avatar: getAvatarUrl(userData?.header || ""),
            id: userData?.userId + "" || "",
            name: userData?.nick || "",
        };
    }, [userData]);

    const getRecentlyPlayedGames = async () => {
        try {
            const res = await apiCasino.getGameHistoryList(1, 15);
            const {status, data} = res;

            if (status === 200 && data.code === 0) {
                const list = data.data.gameList || [];
                setRecentlyGames(getMappedCardList(list, langNavigate));
            }
        } catch (err) {
            notify({
                type: "error",
                title: "Some Error",
            });
        }
    };
    useEffect(() => {
        setTimeout(() => {
            getRecentlyPlayedGames();
        });
    }, []);

    return {
        mutatedUserData,
        vipWidgetData,
        recentlyGames,
        rewards,
    };
};
